import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
var fetch = window.fetch.bind(window);
var URL = window.URL || window.webkitURL;

function decode(response, type) {
  if (!response.ok) {
    var error = new Error("Error loading ".concat(response.url, ": status ").concat(response.status));
    error.reponse = reponse;
    throw error;
  }

  switch (type) {
    case 'text':
      return response.text();

    case 'arrayBuffer':
      return response.arrayBuffer();

    case 'dataURL':
      return response.blob().then(URL.createObjectURL);

    default:
      console.error('unknown decode type', type);
  }
}
/** @module FetchSource */


var FetchSource =
/*#__PURE__*/
function () {
  /** create a source with a read function that fetches and decodes a file
  * @constructor
  * @param {Object} options.fetchOptions - fetching options (see standard js fetch function)
  * @param {string} options.path - path prefix for relative intrinsic files (default: '')
  * @param {function} options.fetch - function (url, fetchOptions) to fetch relative intrinsic files (default: fetch)
  * @param {function} options.decode - function that decodes a response from fetch to a string (default function decodes the result of a standard fetch)
  * @return {function} - the fetching function (url => decoded).
  */
  function FetchSource(path) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, FetchSource);

    this.path = path || '';
    this.fetchOptions = options.fetchOptions || {
      crossOrigin: 'anonymous'
    };
    this.fetch = options.fetch || fetch;
    this.decode = options.decode || decode;
  }

  _createClass(FetchSource, [{
    key: "open",
    value: function open(url, type) {
      var _this = this;

      return this.fetch(this.path + url, this.fetchOptions).then(function (response) {
        return _this.decode(response, type);
      });
    }
  }, {
    key: "close",
    value: function close(url, type) {
      if (type === 'dataURL') {
        URL.revokeObjectURL(url);
      }
    }
  }]);

  return FetchSource;
}();

export default FetchSource;